import { Coding } from "@medplum/fhirtypes";

import { LOINCCodes } from "@/fhir/enums/loinc";
import { EncounterServiceTypeCodes } from "@/fhir/enums/quilted-health";

/**
 * Both the LOINC code (`http://loinc.org`) and the Quilted Health service-type code
 * (`QuiltedHealthCodeSystems.EncounterServiceType`) identify the Transfer of Care template.
 */
const TRANSFER_OF_CARE_TEMPLATE_CODES: string[] = [
  LOINCCodes.TransferOfCareEncounter,
  EncounterServiceTypeCodes.TransferOfCare,
];

/**
 * True when an encounter template coding identifies a Transfer of Care encounter.
 *
 * Matches on `code` alone. Both codes are namespaced to a single system in practice, and a
 * template coding only ever reaches here from the `encounter-service-type` ValueSet expansion or
 * from an `Encounter.serviceType` this application wrote, so `system` adds no discrimination.
 * Requiring it would instead reject historical encounters whose stored `system` predates the
 * current CodeSystem URL.
 *
 * @param template - The encounter template coding, typically `Encounter.serviceType.coding[0]`.
 * @returns `true` for a Transfer of Care template, `false` for any other template or no template.
 */
export const isTransferOfCareTemplate = (template?: Coding): boolean =>
  Boolean(template?.code && TRANSFER_OF_CARE_TEMPLATE_CODES.includes(template.code));
